import { render, staticRenderFns } from "./ContactUs.html?vue&type=template&id=88fdd24a&scoped=true&"
import script from "./ContactUs.js?vue&type=script&lang=js&"
export * from "./ContactUs.js?vue&type=script&lang=js&"
import style0 from "./ContactUs.scss?vue&type=style&index=0&id=88fdd24a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fdd24a",
  null
  
)

export default component.exports